module.exports = __webpack_public_path__ + "static/inpowered-openx-precisely-main-desktop-78c34a0c432f0694e870a339d317cb29.png";